<p class="sub-header" [translateParams]="{ supplyNumberLabel: supplyNumberLabel | lowercase }" translate>iFrame.Subscription.EnterSupplyNumberInfo</p>

<bi-skip-link [label]="'accessibility.GoBack' | translate" (onClick)="onBack.emit()" />

<form [formGroup]="supplyNumberForm" class="grid bi-p-fluid mt-4">
  <div class="col-12 md:col-4 xl:col-3">
    <label for="supply-number" class="FieldLabel">{{ supplyNumberLabel }} </label>
    <input pInputText type="text" maxlength="100" id="supply-number" formControlName="supplyNumber" />
    <div role="alert">
      <p class="field-error" *ngIf="supplyNumberCtrl.errors?.required && supplyNumberCtrl.dirty" translate>errorMessages.MustBeFilled</p>
    </div>
  </div>

  <div class="col-12 md:col-4 xl:col-3">
    <label for="alias" class="FieldLabel">{{ aliasLabel }}</label>
    <input type="text" maxlength="200" id="alias" pInputText formControlName="alias" />
  </div>

  <div class="col-12 flex flex-column md:flex-row gap-2">
    <p-button
      type="submit"
      class="flex-1"
      styleClass="primary-wcag"
      [label]="'shared.Subscribe' | translate"
      [disabled]="supplyNumberForm.invalid"
      (click)="onCreateSubscription.emit(supplyNumberForm.value)"
    />

    <p-button class="flex-1" [ariaLabel]="'shared.Back' | translate" [label]="'shared.Back' | translate" (click)="onBack.emit()" />
  </div>
</form>
